/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * CINEFF - Quick "Add to cart" button on product cards (collection/grid glass cards)
 */
document.addEventListener('click', function (event) {
  var button = event.target.closest('.ProductItem__QuickAdd');

  if (!button || button.disabled) {
    return;
  }

  event.preventDefault();

  var variantId = button.getAttribute('data-variant-id');

  if (!variantId) {
    return;
  }

  var defaultLabel = button.getAttribute('data-label-default') || 'Add to cart';

  button.disabled = true;
  button.classList.add('is-loading');
  button.textContent = 'Adding...';

  fetch(window.routes.cartAddUrl + '.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(function (response) {
      return response.json().then(function (data) {
        return { ok: response.ok, data: data };
      });
    })
    .then(function (result) {
      button.classList.remove('is-loading');

      if (result.ok) {
        button.classList.add('is-added');
        button.textContent = 'Added';

        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { quantity: 1 }
        }));

        setTimeout(function () {
          button.classList.remove('is-added');
          button.disabled = false;
          button.textContent = defaultLabel;
        }, 1800);
      } else {
        button.disabled = false;
        button.textContent = defaultLabel;
      }
    })
    .catch(function () {
      button.classList.remove('is-loading');
      button.disabled = false;
      button.textContent = defaultLabel;
    });
});

/**
 * CINEFF - "Limited time offer" countdown on the product page.
 * Counts down to the visitor's local midnight and resets automatically every day.
 */
(function () {
  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function tick(timer) {
    var hoursEl = timer.querySelector('[data-countdown-hours]');
    var minutesEl = timer.querySelector('[data-countdown-minutes]');
    var secondsEl = timer.querySelector('[data-countdown-seconds]');

    var now = new Date();
    var midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);

    var diff = Math.max(midnight.getTime() - now.getTime(), 0);

    var hours = Math.floor(diff / 3600000);
    var minutes = Math.floor((diff % 3600000) / 60000);
    var seconds = Math.floor((diff % 60000) / 1000);

    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
    if (secondsEl) secondsEl.textContent = pad(seconds);
  }

  function init() {
    var timers = document.querySelectorAll('[data-countdown-timer]');

    if (!timers.length) {
      return;
    }

    timers.forEach(function (timer) {
      tick(timer);
    });

    setInterval(function () {
      timers.forEach(function (timer) {
        tick(timer);
      });
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();